export const COMPANY = {
  name: "Luxe Home Cleaning & Assistance",
  phone: "0431 187 005",
  email: "HavenHomeAssist@outlook.com",
  area: "Brisbane & Gold Coast",
  tagline: "More than cleaning — a helping hand for the whole home.",
};

export const SERVICES = [
  { title: "General & Deep Cleaning", desc: "Regular upkeep or a top-to-bottom reset that makes every room feel new again." },
  { title: "Meal Preparation", desc: "Fresh, home-cooked meals prepped around your family's tastes and schedule." },
  { title: "Laundry & Ironing", desc: "Washed, folded, ironed and put away — laundry days, quietly handled." },
  { title: "Organisation", desc: "Wardrobes, pantries and living spaces, thoughtfully sorted and calmed." },
  { title: "Dog Walking", desc: "Daily walks and companionship so your best friend stays happy and active." },
  { title: "Babysitting", desc: "Trusted, Blue Card–checked care for the little ones when life gets busy." },
  { title: "Errands & Transport", desc: "Groceries, appointments and pickups — the small trips that eat your day." },
  { title: "Bond & Exit Cleaning", desc: "Move-out cleans done to inspection standard so you get your bond back." },
];

export const CREDENTIALS = ["ABN Registered", "Police Checked", "Fully Insured", "Blue Card Verified"];

export const CHAPTERS = [
  { n: "01", title: "Tell us what you need", body: "Share your home, your household and the tasks weighing on you. No task is too big or too small." },
  { n: "02", title: "We match your assistant", body: "You're paired with a reliable, vetted home assistant whose skills fit your household perfectly." },
  { n: "03", title: "Book the hours that suit", body: "A simple hourly rate with a two-hour minimum. Weekly, fortnightly or one-off — you decide." },
  { n: "04", title: "Reclaim your time", body: "Come home to calm. We handle the running of the house so you can focus on what matters." },
];

export const TESTIMONIALS = [
  { quote: "Having the same assistant each week has been life-changing. The house runs itself now.", name: "Sarah M.", role: "Working mum of three" },
  { quote: "From deep cleans to dog walks — one call and it's sorted. Genuinely dependable people.", name: "James & Priya", role: "Ascot" },
  { quote: "The bond clean was flawless. Got our full deposit back without a single follow-up.", name: "Daniel R.", role: "Recent mover" },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
export const FREQUENCIES = ["One-off", "Weekly", "Fortnightly", "Monthly"];
export const HOUR_OPTIONS = ["2 hours", "3 hours", "4 hours", "5+ hours"];

export const SUBURBS = [
  "Brisbane CBD", "New Farm", "Ascot", "Hamilton", "Bulimba", "Paddington",
  "Toowong", "Chermside", "Carindale", "Southport", "Surfers Paradise",
  "Broadbeach", "Robina", "Burleigh Heads", "Coomera", "Mermaid Beach",
];

export const FAQS = [
  {
    q: "What areas do you provide home cleaning and home assistance in?",
    a: "We provide residential cleaning and home assistance right across Brisbane and the Gold Coast, including New Farm, Ascot, Hamilton, Bulimba, Paddington, Toowong, Carindale, Southport, Surfers Paradise, Broadbeach, Robina and Burleigh Heads. If you're nearby and not sure, just ask — we're always expanding.",
  },
  {
    q: "How much does home cleaning cost?",
    a: "We keep pricing refreshingly simple: one transparent hourly rate from $55/hr with a two-hour minimum booking. You're only billed for the time you book, there are no lock-in contracts, and we'll always confirm a clear, personalised quote before we start.",
  },
  {
    q: "What home assistance services do you offer?",
    a: "Much more than cleaning. Our home assistants help with general and deep cleaning, meal preparation, laundry and ironing, home organisation, dog walking, babysitting, errands and transport assistance, plus bond and exit cleaning for clients preparing to move.",
  },
  {
    q: "Are your home assistants police checked and insured?",
    a: "Yes. Every home assistant is a reliable independent contractor who holds an ABN, a current police check, appropriate insurance and, where necessary, a Blue Card — so you can welcome them into your home with complete confidence.",
  },
  {
    q: "Can I book a one-off clean or a regular service?",
    a: "Both. Choose a one-off deep clean, a bond clean before you move, or an ongoing weekly or fortnightly service. Where possible we'll match you with the same trusted assistant each visit for consistency.",
  },
  {
    q: "Do you offer bond and exit cleaning?",
    a: "Absolutely. Our bond and exit cleans are completed to inspection standard, helping you hand back the keys with confidence and get your full deposit back.",
  },
];
